/*
payments/common/lib/core

This is meant to be a small library for some good-to-have functions.

*/

import addRemoveClass from './utils/addremoveclass.js';
import ajaxJquery from './utils/jqajx.js';
import ajaxPostJquery from './utils/jqajx-post.js';
import create from './utils/create.js';
import elements from './utils/elements.js';
import events from './utils/events.js';
import domready from './utils/domready.js';
import aspectHeight from './utils/aspectheight.js';
import nodetree from './utils/nodetree.js';
import imagesize from './utils/imagesize.js';
import stringtrim from './utils/stringtrim.js';
import textkeys from './utils/textkeys.js';

export default {
	addClass(elm, classname) {
		return addRemoveClass.add(elm, classname);
	},
	deleteElement(elm, modulenameUsingTheMethod) {
		return elements.deleteElement(elm, modulenameUsingTheMethod);
	},
	deleteElementsInObjectExcept(obj, keysToIgnoreArr, modulenameUsingTheMethod) {
		return elements.deleteElementsInObjectExcept(obj, keysToIgnoreArr, modulenameUsingTheMethod);
	},
	hasClass(elm, classname) {
		return addRemoveClass.hasClass(elm, classname);
	},
	getElementIfValid(obj, key, modulenameUsingTheMethod) {
		return elements.getElementInObjectIfValid(obj, key, modulenameUsingTheMethod);
	},
	selectElements(objWithSelectors, modulenameUsingTheMethod) {
		return elements.selectElements(objWithSelectors, modulenameUsingTheMethod);
	},
	removeClass(elm, classname) {
		return addRemoveClass.remove(elm, classname);
	},
	create(typeOrConfig, classname, id) {
		return create.basicElement(typeOrConfig, classname, id);
	},
	domready(initFunction) {
		return domready.run(initFunction);
	},
	addListener(parentElm, eventType, eventHandler) { // window.CORE.addListener(someElement, 'click', )
		/*
		The main adavantage of this method
		for registration of dom - listeners is the ability to register before the triggering elements are inserted into the dom.(similar to jquery.on(...))
		Best usage in this
		case is to combine with the 'handle'
		method.
		Example:
		    var clickListenerHandler = function (e) {
		            var cb = function (p) {
		                p.e.stopPropagation();
		                var elm = p.elm,
		                    row = elm.getAttribute('row'),
		                    col = elm.getAttribute('col');
		                actions.clickboard(row, col);
		            };
		            //If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked
		            core.handle(e, '.board_item', cb, true);
		        },
		        addListener = function (parent) {
		            core.addListener(parent, 'click', clickListenerHandler);
		        };
		*/
		return events.add(parentElm, eventType, eventHandler);
	},
	removeListener(parentElm, eventType, eventHandler) {
		/* this method may be called although arguments may be empty */
		events.remove(parentElm, eventType, eventHandler);
	},
	getTextkeysFromString(str, endofkey = '__ENDOFKEY__', endofvalue = '__ENDOFVAL__') {
		// preferred: passing of textkeys separated from dom-object
		return textkeys.objFromString(str, endofkey, endofvalue);
	},
	getTextkeysFromElement(elm, modulenameUsingTheMethod, endofkey = '__ENDOFKEY__', endofvalue = '__ENDOFVAL__') {
		// temporary solution: method that takes the dom-object handling previously done in the 'textkeys' module.
		function getStringFrom(theElement) {
			let str = null;
			if (elements.isElement(theElement)) {
				str = (theElement.dataset ? (theElement.dataset.textkeys || null) : null);
			}
			return str;
		}
		const textkeysAsString = getStringFrom(elm);
		return textkeys.objFromString(textkeysAsString, endofkey, endofvalue);
	},
	handle(event, classSelectorFilter, sendFkn, checkParentFilterHit) {
		return events.handle(event, classSelectorFilter, sendFkn, checkParentFilterHit);
	},
	isElement(elm) {
		return elements.isElement(elm);
	},
	nodetree(optNodeOrArrOfNodes) {
		if (arguments.length > 1) {
			console.warn('control:nodetree: arguments must be sent as an array or only the first argument will be used');
		}
		return nodetree.fragment(optNodeOrArrOfNodes);
	},
	aspectHeight(w, refH, refW) {
		return aspectHeight.scaledHeight(w, refH, refW);
	},
	// onResize(cb) {
	// TODO the resize listener.
	// addListener = function () {
	// window.addEventListener("resize", function () {cb()});
	// };
	// },
	onimagesize(src, cbArgHW) {
		/* returns the size {'w':#, 'h':#} */
		return imagesize.onsize(src, cbArgHW);
	},
	keepdigits(str) {
		/* returns the digits from a string, converted into a number */
		return stringtrim.keepdigits(str);
	},
	multispace(str) {
		return stringtrim.multispace(str);
	},
	trailspace(str) {
		return stringtrim.trailspace(str);
	},
	get(url, successhandler, errorhandler) {
		if (!(successhandler && typeof successhandler === 'function')) {
			console.error('core:request:provide a successhandler: function(data){}');
		}
		if (!(errorhandler && typeof errorhandler === 'function')) {
			console.error('core:request:provide a errorhandler: function(){}');
		}
		// ajaxJquery_crossdomain.getAsString(url, successhandler, errorhandler);
		ajaxJquery.getData(url, successhandler, errorhandler);
	},
	post(url, data, successhandler, errorhandler, contentType) {
		/* errorhandler is optional */
		if (!(successhandler && typeof successhandler === 'function')) {
			console.error('core:post:provide a successhandler: function(data){}: core.post(url,data,successhandler, errorhandler)');
		}
		// if (!(errorhandler && typeof errorhandler === 'function')) {
		//     console.error('core:post:provide a errorhandler: function(){}: core.post(url,data,successhandler, errorhandler)');
		// }
		// ajaxJquery_crossdomain.getAsString(url, successhandler, errorhandler);
		ajaxPostJquery.submit(url, data, successhandler, errorhandler, contentType);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/core.js